import { URL } from '../../../../../config'
import { postRequest } from '../../../../../utils/httpRequest'

export const sendInvalidInfoNotification = function (eventId,details,token) 
{
  const invalidInfoEndpoint = `/${eventId}/invalidinfo`
  
  const  invalidInfoURL =  `${URL.event}${invalidInfoEndpoint}` 
  
  const invalidInfoDetails = {
      eventId,
      details
  }
  console.log('sendInvalidInfoNotification eventId,details,token',invalidInfoURL,invalidInfoDetails,token)
  return postRequest(invalidInfoURL,invalidInfoDetails,token)
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/CorrectEventInfo/api/index.js